import React, { Component } from "react";
import { Col, Card, Form, Collapse } from "antd";
import _ from "lodash";
import momentTZ from "moment-timezone";
import { formatRupiah } from "../../../../Utils";

class RequestSectionFinisih extends Component {
  buttonStatus(request) {
    let button;
    if (request.status === "Approved") {
      button = (
        <div>
          <span className="ant-form-text" style={{ color: "#A4D166" }}>
            Approved by {request.Director.directors_role}{" "}
          </span>
          <span className="ant-form-text" style={{ color: "#002558" }}>
            |{" "}
            {momentTZ(request.updatedAt)
              .tz("Asia/Jakarta")
              .format("ddd, D MMM YYYY HH:mm")}{" "}
            | {request.Director.name}
          </span>
        </div>
      );
    }
    return button;
  }

  getStatusRequest(request) {
    const discount = _.find(request, { status_label: "Discount" });
    const mrp = _.find(request, { status_label: "MRP" });
    return (
      <div>
        {discount && (
          <Form.Item label="Request Discount">
            {this.buttonStatus(discount)}
          </Form.Item>
        )}
        {mrp && (
          <Form.Item label="Request MRP">{this.buttonStatus(mrp)}</Form.Item>
        )}
      </div>
    );
  }

  statusColor(status) {
    status = status ? (status === "Deal" ? "#A4D166" : "#FF1D1D") : null;
    return status;
  }

  render() {
    const { approval, formatRupiah, request, history } = this.props;
    return approval.id ? (
      <Col xs={24} md={12}>
        <Card title="Request Section">
          {this.getStatusRequest(request)}
          <Form.Item label="Harga Final">
            <span className="ant-form-text form-text-mod">
              {approval.finalPrice ? formatRupiah(approval.finalPrice) : "N/A"}
            </span>
          </Form.Item>
          <Form.Item label="Last Status">
            <span
              className="ant-form-text form-text-mod"
              style={{
                color: this.statusColor(approval.approvalStatus),
                fontWeight: "bold",
              }}
            >
              {approval.approvalStatus}{" "}
            </span>
            <span className="ant-form-text form-text-mod">
              {momentTZ(approval.updatedAt)
                .tz("Asia/Jakarta")
                .format("ddd, D MMM YYYY HH:mm")}
            </span>
          </Form.Item>
          {approval.approvalStatus === "No Deal" && (
            <Form.Item label="Alasan Penolakan">
              <span className="ant-form-text form-text-mod">
                {approval.notes}
              </span>
            </Form.Item>
          )}

          {history && history.length > 1 && (
            <Collapse ghost>
              <Collapse.Panel header="Approval History" key="1">
                {history.map(
                  (v, i) =>
                    i !== 0 && (
                      <div>
                        <span
                          className="ant-form-text form-text-mod"
                          style={{
                            color: this.statusColor(v.approvalStatus),
                            fontWeight: "bold",
                          }}
                        >
                          {v.approvalStatus}{" "}
                        </span>
                        <span className="ant-form-text form-text-mod">
                          |{" "}
                          {momentTZ(v.createdAt)
                            .tz("Asia/Jakarta")
                            .format("ddd, D MMM YYYY HH:mm")}{" "}
                          | {v.User.name} | {formatRupiah(v.finalPrice)}
                        </span>
                      </div>
                    )
                )}
              </Collapse.Panel>
            </Collapse>
          )}
        </Card>
      </Col>
    ) : null;
  }
}

export default RequestSectionFinisih;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/RequestSectionFinish.js